const data = {
    title: '6. Kennisleemtes en vervolgonderzoek',
    content: <>
        <p>Dit hoofdstuk beschrijft de leemten in kennis in dit MER en de monitoring en evaluatie van het doelbereik en de milieueffecten van de herziening van de module Energietransitie.</p>
        
    </>,
    prev: '/energietransitie/5/8',
    next: '/energietransitie/6/1',

}

export default data